import { clsx } from "clsx";

import { Container } from "~/components/container";
import { FadeIn } from "~/components/fade-in";

export function SectionIntro({
  title,
  eyebrow,
  children,
  smaller = false,
  ...props
}: Omit<
  React.ComponentPropsWithoutRef<typeof Container>,
  "title" | "children"
> & {
  title: string;
  eyebrow?: string;
  children?: React.ReactNode;
  smaller?: boolean;
}) {
  return (
    <Container {...props}>
      <FadeIn className="max-w-2xl">
        <h2>
          {eyebrow ? (
            <>
              <span className="label mb-5 block text-accent-400">
                {eyebrow}
              </span>
              <span className="sr-only"> - </span>
            </>
          ) : null}
          <span
            className={clsx(
              "block font-display tracking-tight text-ink-50 [text-wrap:balance]",
              smaller
                ? "text-2xl font-semibold"
                : "text-4xl font-medium sm:text-5xl",
            )}
          >
            {title}
          </span>
        </h2>
        {children ? (
          <div className="mt-5 text-lg text-ink-300">{children}</div>
        ) : null}
      </FadeIn>
    </Container>
  );
}
